module.exports = __webpack_public_path__ + "static/media/newUser.56bd647d.svg";